
export default function Docs() {
  return (
    <h4>Documentation</h4>
  );
}
